import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getCalcTypes, saveCalcTypesBatch } from '../../api/calcTypes';
import type { CalcType } from '../../types/CalcType';
import { t } from '../../i18n/t';

const calcTypesColumnDefs: ColDef<CalcType>[] = [
  {
    field: 'calcTypeId',
    headerName: t('calcTypes.columns.calcTypeId'),
    width: 130,
    // Natural PK: editable on Add only.
    editable: (params: EditableCallbackParams<CalcType>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'calcTypeCode',
    headerName: t('calcTypes.columns.calcTypeCode'),
    width: 180,
    editable: true,
  },
  {
    field: 'calcTypeName',
    headerName: t('calcTypes.columns.calcTypeName'),
    flex: 1,
    editable: true,
  },
];

const newCalcTypeDefaults = (): Partial<CalcType> => ({
  calcTypeId: 0,
  calcTypeCode: '',
  calcTypeName: '',
});

export function CalcTypesPage() {
  return (
    <LopCrudPage<CalcType>
      resourceCode="calcTypes"
      titleKey="calcTypes.pageTitle"
      idField="calcTypeId"
      getRows={getCalcTypes}
      saveBatch={(added, modified, deletedIds) =>
        saveCalcTypesBatch(added, modified, deletedIds as number[])
      }
      columnDefs={calcTypesColumnDefs}
      newRowDefaults={newCalcTypeDefaults}
    />
  );
}
